import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { routes, url } from 'oo-routes';

import Link from 'sp-components/components/Link';
import { prettyNumber } from 'sp-components/util';

import './styles';

const CUSTOMER_LOGOS = [
  require('./BDA.png'),
  require('./adidas.png'),
  require('./AmericanSFBrb-1.png'),
  require('./Geiger.png'),
  require('./proforma-one-source-infinate-solutions.png'),
  require('./JNI_2clr.png'),
  require('./fully-promoted.png'),
  require('./big-frog-logo.png'),
];

export default class Testimonials extends React.Component {
  static propTypes = {
  }

  state = {
    index: 0,
  }

  changeIndex = index => () => {
    if (index < 0) {
      index = CUSTOMER_LOGOS.length - 1;
    }
    if (index >= CUSTOMER_LOGOS.length) {
      index = 0;
    }
    this.setState({ index });
  }

  render() {
    return (
      <div className="Testimonials">
        <div className="p-v-2" />
        <div className="p-v-2 computer-only" />
        <div className="ui container">
          <h1 className="center-aligned m-b-2">
            Over 10 million items printed
          </h1>
          <div className="center-aligned">
            <a href={url('website', routes.website.auth.register)} className="ui primary button">
              REQUEST AN ACCOUNT
            </a>
          </div>
        </div>
        <div className="p-v-2 computer-only" />
        <div className="p-v-2 computer-only" />
        <div className="p-v-2" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Footer2/Testimonials/index.jsx